import addModuleToWorklet from "src/modules/audio-processing/addModuleToWorklet";
import createNoiseMeter from "src/modules/audio-processing/createNoiseMeter";
import AudioDecoder from "./lib/AudioDecoder";
import ReceiveBuffer from "./lib/ReceiveBuffer";
import AudioResampler from "./lib/AudioResampler";
import { getModulePublicPathPrefix } from "src/utils/environment";

export default async function createOpusPlayer() {
  let audioContext = new AudioContext();
  let audioDecoder = new AudioDecoder();
  let audioResampler = new AudioResampler(
    1, // Number of channels
    16000, // Original sample rate
    audioContext.sampleRate, // Target sample rate
    0.02 // Frame duration (in seconds)
  );

  await audioDecoder.setup({
    sampling_rate: 16000,
    num_of_channels: 1
  });

  const releaseResources = await addModuleToWorklet(
    audioContext.audioWorklet,
    getModulePublicPathPrefix() + "modules/audio-processing/worklets/player.js"
  );

  let audioWorkletNode = new AudioWorkletNode(audioContext, "player", {
    numberOfInputs: 1,
    numberOfOutputs: 1,
    channelCount: 1
  });

  let gainNode = audioContext.createGain();

  audioWorkletNode.connect(gainNode).connect(audioContext.destination);

  const noiseMeter = await createNoiseMeter({
    audioContext,
    sourceNode: audioWorkletNode
  });
  audioWorkletNode
    .connect(noiseMeter.audioNode)
    .connect(audioContext.destination);

  async function handleData(data) {
    try {
      let packets = ReceiveBuffer.packets(Buffer.from(data));
      for (const packet of packets) {
        const decodedPacket = await audioDecoder.decode(packet);
        const decodedSamples = decodedPacket.samples;
        const result = await audioResampler.process(decodedSamples);

        audioWorkletNode.port.postMessage({
          name: "data",
          payload: result
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  function changeVolume(volume) {
    gainNode.gain.value = volume;
  }

  return {
    noiseMeter,
    onData: handleData,
    volume: changeVolume,
    destroy: () => {
      gainNode.disconnect();
      audioWorkletNode.disconnect();
      noiseMeter && noiseMeter.destroy();
      releaseResources && releaseResources();
    }
  };
}
